<style scoped>
	.windows-sized{
		height : 100vh;
	}
</style>
<template>
	<div class="fade page-sidebar-fixed page-header-fixed show page-container" id="app" v-if="!pageOptions.pageEmpty" v-bind:class="{
		'page-sidebar-minified': pageOptions.pageSidebarMinified,
		'page-content-full-height': pageOptions.pageContentFullHeight,
		'page-without-sidebar': pageOptions.pageWithoutSidebar,
		'page-with-right-sidebar': pageOptions.pageWithRightSidebar,
		'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
		'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
		'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
		'page-with-top-menu': pageOptions.pageWithTopMenu,
		'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
		'page-right-sidebar-toggled': pageOptions.pageMobileRightSidebarToggled || pageOptions.pageRightSidebarToggled,
		'has-scroll': pageOptions.pageBodyScrollTop
	}">
		<Header  v-if="pageOptions.pageWithHeader" />
		<TopMenu v-if="pageOptions.pageWithTopMenu" />
		<Sidebar v-if="!pageOptions.pageWithoutSidebar" />
		<SidebarRight v-if="pageOptions.pageWithTwoSidebar" />
		<div id="content" class="content" style="min-height:90vh; background-color: #F8F8F8;" v-bind:class="{ 'content-full-width': pageOptions.pageContentFullWidth, 'content-inverse-mode': pageOptions.pageContentInverseMode }">
			<router-view></router-view>
			<vue-ins-progress-bar></vue-ins-progress-bar>
		</div>
		<Footer />
	</div>
	<div v-else>
		<router-view></router-view>
		<vue-ins-progress-bar></vue-ins-progress-bar>
	</div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import Header from '@/components/header/Header'
import Footer from '@/components/footer/Footer'
import Sidebar from '@/components/sidebar/Sidebar'
import TopMenu from '@/components/top-menu/TopMenu'
import PageOptions from '@/Options/PageOptions.js'

import { tooltipJson } from '@/Options/tooltip'

export default {
  name: 'app',
  components : {
    Header,
    Footer,
    Sidebar,
    TopMenu
  },
  data(){
	  return{
		  pageOptions : PageOptions,
		  refCount : 0,
		  isLoading : false,
		  logoutStatus : false
	  }
  },
  methods : {
    // setLoading(isLoading){ 
	// 	if (isLoading) {
	// 		this.refCount++;
	// 		this.$swal({
	// 			title: 'Loading.....'
	// 		});
	// 		this.$swal.showLoading();
	// 		this.isLoading = true;
	// 	} else if (this.refCount > 0) {
	// 		this.refCount--;
	// 		this.$swal.close();
	// 		this.isLoading = (this.refCount > 0);
	// 	}
	// },
	logout(){	
			this.$store.dispatch('setUser', null)
			this.$http.defaults.headers.common['Authorization'] = "";

			this.$store.dispatch('setFilterOptions' , null)
			this.$store.state.lastData = null;
			this.$store.state.modules = null;
			this.$router.push({ path :'/login'})
		//delete token 
	}
  },
  created(){
		this.$store.state.tooltip = tooltipJson;

    PageOptions.pageBodyScrollTop = window.scrollY;

		window.addEventListener('scroll', this.handleScroll);

		this.$insProgress.start()

		this.$router.beforeEach((to, from, next) => {
			this.$insProgress.start()
			next()
		})
		this.$router.afterEach(() => {
			this.$insProgress.finish()
		})

		var user = this.$store.state.userData.userData;

		if (user) {
			this.$http.defaults.headers.common['Authorization'] = "Bearer " + user.token;
		}
		

		this.$http.interceptors.request.use((config) => {
			
			if(config.url.includes('?')) {
				let splitUrl = config.url.split("?")
				let queryUrl = splitUrl[1].split('&')

				for(var i = 0 ; i < queryUrl.length ; i++) {
					if(queryUrl[i].includes('start=')) {
						queryUrl[i] = queryUrl[i] + ' 00:00:00'
					}
					if(queryUrl[i].includes('end=')) {
						queryUrl[i] = queryUrl[i] + ' 23:59:59'
					}
				}

				queryUrl = queryUrl.join('&')
				config.url = splitUrl[0] + "?" +  queryUrl
			}

			// if(!config.url.includes('/v1/masterData'))
			// 	this.setLoading(true);

			return config;
		}, (error) => {
			// this.setLoading(false);
			console.log(error)
			return Promise.reject(error);
		});

		this.$http.interceptors.response.use(async (response) => {
			// this.setLoading(false);
			//if response is xlsx file, continue request
			if(response.headers["content-type"] == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
				return response;
			// console.log(response.status)
			//if response code is 200, continue request
			if(response.status == 200){
				return response;
			}
			else {
				return Promise.reject(error)
			}
		},async  (error) => {
			// this.setLoading(false);
			console.log(error.response)
			if (typeof error.response === "undefined") {
				return Promise.reject("Error");
			} 
			else if(error.response.status == 401 ){
				this.$swal.fire({
                    title: 'You have been logged out!',
                    text: "Login session has expired, please re-login to continue.",
                    icon: 'warning',
				})
				await this.logout();
				return new Promise(() => {});
			}
			
			return Promise.reject(error);
		});
  }
}
</script>

<style>
	/* FLATPICKR CUSTOM CSS START */
	input[readonly].flatpickr-input{
		background-color:#fff !important;
		height:43px;
	}

	input[readonly].elegant-flatpickr {
		background-color:#fff !important;
		border: 0;
		height:36px;
        box-shadow: 0 0 6px #0000000F;
		border-radius: 5px;
		font: normal normal bold 14px/15px;
		color: black;
	}

	input[readonly].grey-flatpickr {
		background-color:#EDEDED !important;
		border: 0;
		height:36px;
        box-shadow: 0 0 6px #0000000F;
		border-radius: 5px;
		font: normal normal bold 14px/15px;
		color: black;
	}
	/* FLATPICKR CUSTOM CSS END */

	/* ELEGANT BUTTON START */
    .btn-elegant-download {
        box-shadow: 0px 2px 6px #0000001A;
        border-radius: 5px;
        /* font: normal normal 500 10px/11px Ubuntu; */
        color: #676767;
		width: 100%;
		height: 36px;
    }

    .btn-elegant {
        background: #FFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #00000014;
        border: 0.5px solid #EEE;
        padding: 0.5rem 2rem;
        font: normal normal 500 10px/11px Ubuntu;
    }

    .btn-elegant-unselected {
        background: #EEE 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #00000014;
        padding: 0.5rem 2rem;
        font: normal normal 500 10px/11px Ubuntu;
    }
	/* ELEGANT BUTTON END */

	/* ELEGANT MULTISELECT START */
	.elegant-multiselect {
		font-size:12px;
		margin: 0;
	}

	.elegant-multiselect > .multiselect__tags {
		border : 0px solid white;
		min-height: 36px;
		padding-top: 10px;
	}

	.elegant-multiselect > .multiselect__select {
		height: 36px;
	}
	.elegant-multiselect {
		min-height: 36px;
		box-shadow: 0px 2px 6px #0000001A;
		border-radius: 5px;
		font: normal normal 500 10px/11px Ubuntu;
		color: #676767;
	}
	.elegant-multiselect .multiselect__placeholder {
		font-weight: bold;
		color: black;
	}
	.elegant-multiselect .multiselect__select::before {
		border-color: black transparent transparent;
	}
	/* ELEGANT MULTISELECT END */

	/* TMS MULTISELECT START */
	.tms-multiselect {
		font-size:12px;
		margin: 0;
	}

	.tms-multiselect > .multiselect__tags {
		border : 0px solid white;
		min-height: 36px;
		padding-top: 10px;
		background-color: #EDEDED;
	}
	.tms-multiselect .multiselect__input,
	.tms-multiselect .multiselect__single {
		background-color: #EDEDED;
		color: #383838;
	}

	.tms-multiselect > .multiselect__select {
		height: 36px;
	}
	.tms-multiselect {
		min-height: 36px;
		box-shadow: 0px 2px 6px #0000001A;
		border-radius: 5px;
		font: normal normal 500 10px/11px Ubuntu;
		color: #676767;
	}
	.tms-multiselect .multiselect__placeholder {
		color: black;
		font-size: 16px;
	}
	.tms-multiselect .multiselect__select::before {
		border-color: black transparent transparent;
		top: 50%;
		margin-top: -8.5px;
	}
	/* TMS MULTISELECT END */

	table.tableBodyScroll tbody {
		/* display: block; */
		max-height: 300px;
		overflow: scroll;
	}

	table.tableBodyScroll thead, table.tableBodyScroll tbody tr {
		display: table;
		width: 100%;
		table-layout: fixed;
	}
	/* table.tableBodyScroll tbody {
		display: block;
		max-height: 500px;
		overflow-y: scroll;
	}

	table.tableBodyScroll thead, table.tableBodyScroll tbody tr {
		display: table;
		width: 100%;
		table-layout: fixed;
	} */
</style>
<!-- 
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .stats-outer-box{
    padding:20px;
  }

  .stats-inner-box{
    border-radius: 10px;
    background-color: #348FE2;
    height: 85px;
  }

  .stats-inner-box p, .stats-inner-box h2{
    color: white;
  }
  .stats-inner-box p{
    margin:5% 0 0 12.5%;
  }
  .stats-inner-box .stats-value{
    margin-top: 0;
    margin-left:10%;
    font-size: 2em;
    font-weight: 500;
  }
  .stats-inner-box .stats-value .stats-value-support{
    font-size: 0.5em;
    font-weight: normal;
  }
  .stats-inner-box h2{
    margin-left:10%
  }
  .stats-inner-box .icon{
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .stats-inner-box .icon i{
    color: #00000050;
    font-size: 3em;
  }

  .outer-box{
    padding:20px;
  }
  .inner-box{
    border-radius: 10px;
    background-color: #fff;
    padding: 20px;
    height: 85px;
  }
</style> -->


